export default "__VITE_ASSET__r6Zrshqn__"